import { Grid, makeStyles, MenuItem, Select, Typography } from "@material-ui/core";
import Chart from "chart.js/auto";
import React, { useRef, useEffect, useState } from "react";
import { listSecurities } from "../services/restqlService";

const useStyles = makeStyles({
    root: {
        height: "100%",
        flexDirection: "column",
        display: "flex",
    },
    topSecurities: {
        paddingBottom: "0.5rem",
    },
    securitiesSelect: {
        width: "9rem",
    },
    selectGrid: {
        paddingBottom: "1rem",
    },
    selectLabel: {
        paddingRight: "1rem",
    },
    chartCanvas: {
        height: "20.5rem",
    },
});

const SecuritiesSentimentChart = ({ streamData, clearData }) => {
    const classes = useStyles();

    const [security, setSecurity] = useState("");
    const [securitiesList, setSecuritiesList] = useState([]);
    const [chartData, setChartData] = useState([]);

    const chartRef = useRef(null);
    const sentimentChartDomRef = useRef(null);

    const fetchSecurities = async () => {
        const _securitiesList = await listSecurities();
        if (_securitiesList && _securitiesList.result && _securitiesList.result.length) {
            setSecuritiesList([..._securitiesList.result]);
            setSecurity(_securitiesList.result[0].name);
        }
    };

    const updateChart = () => {
        let result = [];
        result = streamData.find(({ SecurityName }) => SecurityName === security) || [];
        let tempArr = [];
        if (result && result.SecurityName) {
            tempArr.push(result.PositiveSentimentVerified);
            tempArr.push(result.NegativeSentimentVerified);
            tempArr.push(result.NeutralSentimentVerified);
            setChartData(() => [...tempArr]);
        }
    };

    useEffect(() => {
        if (clearData && chartRef.current) {
            setChartData(() => []);
            chartRef.current.data.datasets[0].data = [];
            chartRef.current.update();
        }
    }, [clearData]);

    useEffect(() => {
        if (!securitiesList.length) {
            fetchSecurities();
        }
    }, [securitiesList, fetchSecurities]);

    useEffect(() => {
        if (security) {
            updateChart();
        }
    }, [security, streamData]);

    useEffect(() => {}, [chartData]);

    useEffect(() => {
        if (chartRef.current && chartData && chartData.length > 0) {
            chartRef.current.data.datasets[0].data = clearData ? [] : chartData;
            chartRef.current.update();
        }
    }, [chartRef.current, chartData]);

    useEffect(() => {
        if (!chartRef.current && sentimentChartDomRef.current) {
            chartRef.current = new Chart(sentimentChartDomRef.current, {
                type: "bar",
                data: {
                    labels: ["Positive", "Negative", "Neutral"],
                    datasets: [
                        {
                            data: chartData,
                            backgroundColor: [
                                "rgba(153, 102, 255, 1)",
                                "rgba(153, 102, 255, 0.3)",
                                "rgba(153, 102, 255, 0.6)",
                            ],
                            borderWidth: 1,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: false,
                    },
                    scales: {
                        x: {
                            grid: {
                                display: false,
                            },
                        },
                        y: {
                            grid: {
                                display: false,
                            },
                        },
                    },
                },
            });
        }
    }, []);

    const handleChange = (event) => {
        setSecurity(event.target.value);
    };

    return (
        <div className={classes.root}>
            <Grid container alignItems="center" className={classes.selectGrid}>
                <Grid item>
                    <Typography variant="subtitle2" className={classes.selectLabel}>
                        Security Sentiment:
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Select
                        className={classes.securitiesSelect}
                        variant="outlined"
                        value={security}
                        onChange={handleChange}
                    >
                        {securitiesList.map((_security, index) => {
                            return (
                                <MenuItem key={index} value={_security.name}>
                                    {_security.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </Grid>
            </Grid>
            <div className={classes.chartCanvas}>
                <canvas ref={sentimentChartDomRef} />
            </div>
        </div>
    );
};

export default SecuritiesSentimentChart;
